export const NATIONALITIES = [
  { label: "Afghan", value: "afghan", currency: "AFN", code: "AF" },
  { label: "Albanian", value: "albanian", currency: "ALL", code: "AL" },
  { label: "Algerian", value: "algerian", currency: "DZD", code: "DZ" },
  { label: "American", value: "american", currency: "USD", code: "US" },
  { label: "Argentinian", value: "argentinian", currency: "ARS", code: "AR" },
  { label: "Australian", value: "australian", currency: "AUD", code: "AU" },
  { label: "Austrian", value: "austrian", currency: "EUR", code: "AT" },
  { label: "Bahraini", value: "bahraini", currency: "BHD", code: "BH" },
  { label: "Bangladeshi", value: "bangladeshi", currency: "BDT", code: "BD" },
  { label: "Belgian", value: "belgian", currency: "EUR", code: "BE" },
  { label: "Brazilian", value: "brazilian", currency: "BRL", code: "BR" },
  { label: "British", value: "british", currency: "GBP", code: "GB" },
  { label: "Bulgarian", value: "bulgarian", currency: "BGN", code: "BG" },
  { label: "Cambodian", value: "cambodian", currency: "USD", code: "KH" },
  { label: "Canadian", value: "canadian", currency: "CAD", code: "CA" },
  { label: "Chilean", value: "chilean", currency: "CLP", code: "CL" },
  { label: "Chinese", value: "chinese", currency: "CNY", code: "CN" },
  { label: "Colombian", value: "colombian", currency: "COP", code: "CO" },
  { label: "Costa Rican", value: "costa rican", currency: "CRC", code: "CR" },
  { label: "Croatian", value: "croatian", currency: "EUR", code: "HR" },
  { label: "Cuban", value: "cuban", currency: "CUP", code: "CU" },
  { label: "Czech", value: "czech", currency: "CZK", code: "CZ" },
  { label: "Danish", value: "danish", currency: "DKK", code: "DK" },
  { label: "Dominican", value: "dominican", currency: "DOP", code: "DO" },
  { label: "Dutch", value: "dutch", currency: "EUR", code: "NL" },
  { label: "Egyptian", value: "egyptian", currency: "EGP", code: "EG" },
  { label: "Emirati", value: "emirati", currency: "AED", code: "AE" },
  { label: "Ethiopian", value: "ethiopian", currency: "ETB", code: "ET" },
  { label: "Filipino", value: "filipino", currency: "PHP", code: "PH" },
  { label: "Finnish", value: "finnish", currency: "EUR", code: "FI" },
  { label: "French", value: "french", currency: "EUR", code: "FR" },
  { label: "Georgian", value: "georgian", currency: "GEL", code: "GE" },
  { label: "German", value: "german", currency: "EUR", code: "DE" },
  { label: "Ghanaian", value: "ghanaian", currency: "GHS", code: "GH" },
  { label: "Greek", value: "greek", currency: "EUR", code: "GR" },
  { label: "Hungarian", value: "hungarian", currency: "HUF", code: "HU" },
  { label: "Icelandic", value: "icelandic", currency: "ISK", code: "IS" },
  { label: "Indian", value: "indian", currency: "INR", code: "IN" },
  { label: "Indonesian", value: "indonesian", currency: "IDR", code: "ID" },
  { label: "Iraqi", value: "iraqi", currency: "IQD", code: "IQ" },
  { label: "Irish", value: "irish", currency: "EUR", code: "IE" },
  { label: "Israeli", value: "israeli", currency: "ILS", code: "IL" },
  { label: "Italian", value: "italian", currency: "EUR", code: "IT" },
  { label: "Jamaican", value: "jamaican", currency: "JMD", code: "JM" },
  { label: "Japanese", value: "japanese", currency: "JPY", code: "JP" },
  { label: "Jordanian", value: "jordanian", currency: "JOD", code: "JO" },
  { label: "Kazakh", value: "kazakh", currency: "KZT", code: "KZ" },
  { label: "Kenyan", value: "kenyan", currency: "KES", code: "KE" },
  { label: "Korean", value: "korean", currency: "KRW", code: "KR" },
  { label: "Kuwaiti", value: "kuwaiti", currency: "KWD", code: "KW" },
  { label: "Lebanese", value: "lebanese", currency: "LBP", code: "LB" },
  { label: "Malaysian", value: "malaysian", currency: "MYR", code: "MY" },
  { label: "Maldivian", value: "maldivian", currency: "MVR", code: "MV" },
  { label: "Mexican", value: "mexican", currency: "MXN", code: "MX" },
  { label: "Moroccan", value: "moroccan", currency: "MAD", code: "MA" },
  { label: "Nepalese", value: "nepalese", currency: "NPR", code: "NP" },
  { label: "New Zealander", value: "new zealander", currency: "NZD", code: "NZ" },
  { label: "Nigerian", value: "nigerian", currency: "NGN", code: "NG" },
  { label: "Norwegian", value: "norwegian", currency: "NOK", code: "NO" },
  { label: "Omani", value: "omani", currency: "OMR", code: "OM" },
  { label: "Pakistani", value: "pakistani", currency: "PKR", code: "PK" },
  { label: "Panamanian", value: "panamanian", currency: "PAB", code: "PA" },
  { label: "Peruvian", value: "peruvian", currency: "PEN", code: "PE" },
  { label: "Polish", value: "polish", currency: "PLN", code: "PL" },
  { label: "Portuguese", value: "portuguese", currency: "EUR", code: "PT" },
  { label: "Qatari", value: "qatari", currency: "QAR", code: "QA" },
  { label: "Romanian", value: "romanian", currency: "RON", code: "RO" },
  { label: "Russian", value: "russian", currency: "RUB", code: "RU" },
  { label: "Rwandan", value: "rwandan", currency: "RWF", code: "RW" },
  { label: "Saudi", value: "saudi", currency: "SAR", code: "SA" },
  { label: "Serbian", value: "serbian", currency: "RSD", code: "RS" },
  { label: "Singaporean", value: "singaporean", currency: "SGD", code: "SG" },
  { label: "South African", value: "south african", currency: "ZAR", code: "ZA" },
  { label: "Spanish", value: "spanish", currency: "EUR", code: "ES" },
  { label: "Sri Lankan", value: "sri lankan", currency: "LKR", code: "LK" },
  { label: "Swedish", value: "swedish", currency: "SEK", code: "SE" },
  { label: "Swiss", value: "swiss", currency: "CHF", code: "CH" },
  { label: "Tanzanian", value: "tanzanian", currency: "TZS", code: "TZ" },
  { label: "Thai", value: "thai", currency: "THB", code: "TH" },
  { label: "Tunisian", value: "tunisian", currency: "TND", code: "TN" },
  { label: "Turkish", value: "turkish", currency: "TRY", code: "TR" },
  { label: "Ugandan", value: "ugandan", currency: "UGX", code: "UG" },
  { label: "Ukrainian", value: "ukrainian", currency: "UAH", code: "UA" },
  { label: "Uzbek", value: "uzbek", currency: "UZS", code: "UZ" },
  { label: "Venezuelan", value: "venezuelan", currency: "VES", code: "VE" },
  { label: "Vietnamese", value: "vietnamese", currency: "VND", code: "VN" },
];

export const getNationalityCurrency = (nationality) => {
  const n = NATIONALITIES.find(n => n.value === nationality?.toLowerCase());
  return n?.currency || "USD";
};
